<script>
import TwCheckbox from '@/components/generic/forms/tw-checkbox.vue'
import TwTextarea from '@/components/generic/forms/tw-textarea.vue'
import TwInput from '@/components/generic/forms/tw-input.vue'
import { useOrganizationStore } from '@/stores/organization.js'
import TwValidationErrors from '@/components/generic/tw-validation-errors.vue'
import TwButton from '@/components/generic/tw-button.vue'
import AddressEditCard from '@/components/address/address-edit-card.vue'
import { useOrganizationPublicStore } from '@/stores/organizationPublic.js'

export default {
  name: 'OrganizationEdit',
  components: { AddressEditCard, TwButton, TwValidationErrors, TwInput, TwTextarea, TwCheckbox },
  props: {
    hideSubmitButtons: {
      type: Boolean,
      default: false
    },
    public: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Object,
      default: () => ({
        name: null,
        address_street: null,
        address_city: null,
        address_state: null,
        address_zip: null,
        tax_id: null,
        website_url: null,
        description: null,
        nonprofit: true,
        guide_star_link: null,
        phone: null,
      })
    }
  },
  emits: ['update:modelValue', 'updated', 'created'],
  data() {
    return {
      Organization: {
        ...this.modelValue
      },
      Address: {

      },
      Loading: false,
      ValidationErrorMessage: null,
    }
  },
  computed: {
    store() {
      if(this.public) {
        return useOrganizationPublicStore
      }
      else {
        return useOrganizationStore
      }
    }
  },
  watch: {
    modelValue: {
      handler(newVal) {
        // this is in case it changes from the outside
        this.Organization = { ...newVal };
      },
      deep: true
    }
  },
  beforeMount () {
    if(this.Organization.address) {
      this.Address = this.Organization.address
    }
  },
  methods: {
    emitUpdate() {
      this.$emit('update:modelValue', this.Organization);
    },
    save(){
      if(this.Organization.id) {
        this.organizationPatch()
      }
      else {
        this.organizationCreate()
      }
    },
    async organizationPatch() {
      try {
        this.Loading = true
        this.Organization = await this.store().itemPatch({
          ...this.Organization,
          ...this.Address
        })
        this.Loading = false
        this.$emit('updated', this.Organization)
        this.$notify('Organization updated successfully', 'success')
        this.emitUpdate()
      } catch (e) {
        if(e.response) {
          this.ValidationErrorMessage = e.response.data
        }
        this.Loading = false
        throw e //in case it's needed in the upper levels
      }
    },
    async organizationCreate() {
      try {
        this.Loading = true
        this.Organization = await this.store().itemCreate({
          ...this.Organization,
          ...this.Address
        })
        this.Loading = false
        this.$emit('created', this.Organization)
        this.emitUpdate()
      } catch (e) {
        if(e.response) {
          console.log(e.response)
          this.ValidationErrorMessage = e.response.data
        }
        this.Loading = false
        throw e //in case it's needed in the upper levels
      }
    }
  }
}
</script>

<template>
  <fieldset @input="emitUpdate">
    <div class="form-spacing">
    <tw-input v-model="Organization.name" required label="Organization Name*" />
    <address-edit-card v-model="Address"/>
    <tw-input v-model="Organization.tax_id" required label="Tax ID Number*" />
    <tw-checkbox v-model="Organization.nonprofit" readonly label="My organization tax exempt (only non profit organizations are supported for now)"/>
    <tw-input v-model="Organization.website_url" label="Website" />
    <tw-textarea v-model="Organization.description" required label="Description">
      <template #under>
        <p class="text-sm text-gray-600 mt-2">
          Please Keep it brief and pithy. If people want more information they can click on your website link.
        </p>
      </template>
    </tw-textarea>


    <!--    <div class="mt-2">-->
    <!--      <span class="text-sm font-semibold float-right text-blue-900"> <a href="https://www.guidestar.org/search">Look up my GuideStar profile</a> </span>-->
    <!--      <tw-input v-model="Organization.guide_star_link" label="GuideStar Link (optional)" />-->
    <!--    </div>-->
    <div class="grid sm:grid-cols-2 gap-2 sm:gap-4">
      <tw-input v-model="Organization.phone" required label="Phone" />
    </div>
    <tw-validation-errors :validation-result-error="ValidationErrorMessage" />
    <template v-if="!hideSubmitButtons">
      <div v-if="Organization.id" class="flex justify-center mt-4 mb-2">
        <tw-button :loading="Loading" variant="primary" size="padded" block @click="save" class="w-full sm:w-auto">
          Save Changes
        </tw-button>
      </div>
      <div v-else class="flex justify-center mt-4 mb-2">
        <tw-button :loading="Loading" variant="primary" size="padded" block @click="save" class="w-full sm:w-auto">
          Create Organization
        </tw-button>
      </div>
    </template>
  </div>

  </fieldset>
</template>

<style scoped>

</style>
